import {
  ControlsHeight,
  ControlsHeightContext,
} from '@jetbrains/ring-ui/components/global/controls-height'
import * as React from 'react'

import {useAppDispatch, useAppSelector} from '../../../../../../../hooks/react-redux'
import {feedbackForm, ShowFeedbackFormReasons} from '../Feedback.slice'

import FeedbackFormComment from './FeedbackForm.comment'
import FeedbackFormControls from './FeedbackForm.controls'
import {useFeedbackFormModel} from './FeedbackForm.hooks'
import FeedbackFormRating from './FeedbackForm.rating'
import FeedbackFormTags from './FeedbackForm.tags'

import styles from './FeedbackForm.css'

function FeedbackForm() {
  const dispatch = useAppDispatch()
  const rating = useAppSelector(state => state.pipelines.feedbackForm.userInput.rating)
  const reason = useAppSelector(state => state.pipelines.feedbackForm.visibility.reason)

  const showCommentField = useAppSelector(
    state => state.pipelines.feedbackForm.misc.showCommentField,
  )

  const {sendResult, onSubmit, onCancel} = useFeedbackFormModel()
  const onRatingSelect = React.useCallback(
    (value: number) => dispatch(feedbackForm.actions.setRating(value)),
    [dispatch],
  )

  const onTagsSelect = React.useCallback(
    (tags: Array<string>) => dispatch(feedbackForm.actions.setTags(tags)),
    [dispatch],
  )

  const onTypeText = React.useCallback(
    (text: string) => dispatch(feedbackForm.actions.setComment(text)),
    [dispatch],
  )

  const successMessage = React.useMemo(
    () => (
      <div className={styles.section}>
        <p className={styles.subtitle}>{'Thank you for your feedback!'}</p>
        <p className={styles.text}>
          {
            'We put a high value on your opinion as it helps us to continuously improve the user experience.'
          }
        </p>
      </div>
    ),
    [],
  )

  return (
    <ControlsHeightContext.Provider value={ControlsHeight.M}>
      {sendResult.isSuccess ? (
        successMessage
      ) : (
        <>
          {reason !== ShowFeedbackFormReasons.STUCK ? (
            <FeedbackFormRating onRatingSelect={onRatingSelect} />
          ) : null}
          {rating || reason === ShowFeedbackFormReasons.STUCK ? (
            <FeedbackFormTags onTagsSelect={onTagsSelect} />
          ) : null}
          {showCommentField ? <FeedbackFormComment onTypeText={onTypeText} /> : null}
        </>
      )}
      <FeedbackFormControls
        loader={sendResult.isLoading}
        final={sendResult.isSuccess}
        onSubmit={onSubmit}
        onCancel={onCancel}
      />
      {sendResult.error ? <p className={styles.error}>{sendResult.error as string}</p> : null}
    </ControlsHeightContext.Provider>
  )
}

export default React.memo(FeedbackForm)
